import { ReactElement } from 'react';
import { styled } from 'styled-components';
import { Empty } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import type { Recording } from '@minutes-system/backend/src/api/recordings/schema';
import { blockStyle } from '../../../../../components/styles/Block';
import layoutStyle from '../../../../../components/styles/Layout';
import Title from './Title';
import Pagination from './Pagination';
import CardGrid from './CardGrid';
import calcDisplay from '../../utils/calcDisplay';

const ResultsBlock = styled.article`
  ${blockStyle}
  border-radius: 8px;
`;

const ResultsLayout = styled.div`
  ${layoutStyle}
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 8px;
`;

const NoResults = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 64px 0;
`;

const EmptyIcon = styled(FileSearchOutlined)`
  font-size: 48px;
  color: #bfbfbf;
`;

const StyledEmpty = styled(Empty)`
  .ant-empty-image {
    margin-bottom: -16px;
  }
`;

interface Props {
  recordings: Recording[];
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

const Results = ({ recordings, page, pageSize, total, onPageChange }: Props): ReactElement => {
  const { displayStart, displayEnd } = calcDisplay(page, pageSize, total);

  if (recordings.length === 0) {
    return (
      <ResultsBlock>
        <NoResults>
          <StyledEmpty
            image={<EmptyIcon />}
            description={
              <>
                <div>検索条件に一致する録音がありません</div>
                <div>検索条件を変更してください</div>
              </>
            }
          />
        </NoResults>
      </ResultsBlock>
    );
  }

  return (
    <ResultsBlock>
      <ResultsLayout>
        <Title total={total} displayStart={displayStart} displayEnd={displayEnd} />
        <CardGrid recordings={recordings} />
        <Pagination current={page} total={total} pageSize={pageSize} onChange={onPageChange} />
      </ResultsLayout>
    </ResultsBlock>
  );
};

export default Results;
